module.exports = __webpack_public_path__ + "img/question.0ce8c42a.svg";